import { render, staticRenderFns } from "./AqtIndex.vue?vue&type=template&id=4f63180b&scoped=true&"
import script from "./AqtIndex.vue?vue&type=script&lang=js&"
export * from "./AqtIndex.vue?vue&type=script&lang=js&"
import style0 from "./AqtIndex.vue?vue&type=style&index=0&id=4f63180b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63180b",
  null
  
)

export default component.exports